import { useEffect, useRef, useState } from 'react';
import type { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useSettings } from '@wu/widget-core';
import type { StripeIntegrationSettings } from '../../common';

export function useStripe(handleLoadError: () => void) {
  const {
    integrationStripe: { publishableKey }
  } = useSettings<StripeIntegrationSettings>();

  const [stripe, setStripe] = useState<Stripe | null>(null);
  const lastValidKey = useRef('');

  useEffect(() => {
    if (
      !publishableKey ||
      (stripe && publishableKey === lastValidKey.current)
    ) {
      return;
    }

    let aborted = false;

    loadStripe(publishableKey)
      .then((instance) => {
        if (aborted) {
          return;
        }

        if (!instance) {
          handleLoadError();
          setStripe(null);

          return;
        }

        lastValidKey.current = publishableKey;
        setStripe(instance);
      })
      .catch(() => {
        if (!aborted) {
          handleLoadError();
          setStripe(null);
        }
      });

    return () => {
      aborted = true;
    };
  }, [publishableKey, handleLoadError, stripe]);

  return stripe;
}
